// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLoginOutlinedSvg from "@fishx/icons-svg/es/asn/PLoginOutlined";
import FishxIcon from '../components/FishxIcon';

var PLoginOutlined = function PLoginOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLoginOutlinedSvg
  }));
};

PLoginOutlined.displayName = 'PLoginOutlined';
export default React.forwardRef(PLoginOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLoginOutlined.js
// module id = 3500
// module chunks = 0